import 'lazysizes';
window.bootstrap = require('bootstrap');
import barrating from 'jquery-bar-rating';
window.Cookies = require('js-cookie');
